import Federated from '../assets/federated-new.svg';
import Google from '../assets/google-new.svg';
import Spectra from '../assets/Spectra.svg';

export const SasProviders = [
  {
    img: Federated,
    alt: 'federated',
  },
  {
    img: Google,
    alt: 'google',
  },
];

export const TaranaBands = [
  {
    name: '3.5GHz',
    value: '3g'
  },
  {
    name: '5GHz',
    value: '5g'
  },
  {
    name: '6GHz',
    value: '6g'
  }
]

export const AFCProviders = [
  {
    img: Spectra,
    alt: 'spectra',
  },
  {
    img: Federated,
    alt: 'federated',
  },
];
